import { SalesStatementSettings } from "./models/sales-statement-settings.model";

export const DEFAULT_LANGUAGE: string = 'pl'
export const CURRENT_LANGUAGE: string = 'current-language';
export const LOGO: string = 'logo';
export const SALES_STATEMENT_SETTINGS: string = 'sales-statement-settings';

export const ROUTE_SIGN_IN: string = '/sign-in';
export const ROUTE_HOME: string = '/home';
export const ROUTE_FORBIDDEN: string = '/forbidden';
export const ROUTE_ACCESS_DENIED: string = '/access-denied';

export const DEBOUNCE_TIME_FILTERING: number = 500;

//PAGINATION

export const PAGE_SIZE_DEFAULT: number = 50;
export const PAGE_SIZE_OPTIONS: number[] = [50, 100, 150];

export const DATE_FORMAT = {
  parse: {
    dateInput: 'YYYY-MM-DD',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

export const DATE_TIME_FORMAT = {
  parse: {
    dateInput: 'YYYY-MM-DD',
    monthInput: 'MMMM',
    yearInput: 'YYYY',
    timeInput: 'HH:mm',
    datetimeInput: 'YYYY-MM-DD HH:mm',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthInput: 'MMMM',
    yearInput: 'YYYY',
    timeInput: 'HH:mm',
    datetimeInput: 'YYYY-MM-DD HH:mm',
    monthYearLabel: 'YYYY MMMM',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
    popupHeaderDateLabel: 'MMM DD, ddd',
  },
};
